import React from 'react';

class PageTitle extends React.Component {
    render() {
        const { title, subhead } = this.props;

        return (
            <div>
                <h3 className="page-title">{title}</h3>
                <h3 className="page-subhead subhead">{subhead}</h3>
            </div>
        );
    }
}

export default PageTitle;



// WEBPACK FOOTER //
// ./src/common/components/PageTitle.js